/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import '@fortawesome/fontawesome-free/css/all.css';
Vue.config.productionTip = false
import Dialog from './components/Dialog';
import IssueDialog from './components/IssueDialog';
import Input from "./components/Input.vue";
import Treeselect from "@riophae/vue-treeselect";
import "./assets/css/bsgrid.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("dsdInput", Input);
Vue.component("treeselect", Treeselect);
Vue.component('dsdDialog', Dialog);
Vue.component('issueDialog', IssueDialog);
new Vue({
  render: h => h(App),
}).$mount('#app')
